import { M3CONDIPROMO } from "./M3CONDIPROMO.class";

export class M3CONDIAGRUPACION{
    public IdPromocion:number;
    public IdAgrupacion:number;
    public IdCondiciones:string;
    public Operador:string;

    public M3CONDIPROMO:Array<M3CONDIPROMO>;
}